import '@/global.css';

import { Platform } from 'react-native';

export const Colors = {
  light: {
    text: '#0d1a3b',
    background: '#f7f8fb',
    backgroundElement: '#eef1f6',
    backgroundSelected: '#e2e6ee',
    textSecondary: '#6b7385',

    card: '#ffffff',
    cardForeground: '#0d1a3b',
    primary: '#233868',
    primaryForeground: '#f8f9fc',
    secondary: '#eef1f6',
    secondaryForeground: '#233868',
    muted: '#eef1f6',
    mutedForeground: '#6b7385',
    accent: '#fbf1dc',
    accentForeground: '#7a5915',
    border: '#e2e6ee',
    input: '#e2e6ee',
    ring: '#c7a35c',
    gold: '#c7a35c',
    goldForeground: '#fffdf6',
    navy: '#233868',
    destructive: '#d9424e',
    chart4: '#4bab7a',
  },
  dark: {
    text: '#f8f9fc',
    background: '#0f1116',
    backgroundElement: '#1c1f27',
    backgroundSelected: '#262a34',
    textSecondary: '#a6acb8',

    card: '#1c1f27',
    cardForeground: '#f8f9fc',
    primary: '#f0f1f5',
    primaryForeground: '#1c1f27',
    secondary: '#262a34',
    secondaryForeground: '#f8f9fc',
    muted: '#262a34',
    mutedForeground: '#a6acb8',
    accent: '#3a2f14',
    accentForeground: '#f0d18a',
    border: '#2a2e38',
    input: '#2a2e38',
    ring: '#c7a35c',
    gold: '#d4b26d',
    goldForeground: '#1c1f27',
    navy: '#f0f1f5',
    destructive: '#e26370',
    chart4: '#5cbe8b',
  },
} as const;

export type ThemeColor = keyof typeof Colors.light & keyof typeof Colors.dark;

export const Fonts = Platform.select({
  ios: {
    sans: 'system-ui',
    serif: 'ui-serif',
    rounded: 'ui-rounded',
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: 'var(--font-display)',
    serif: 'var(--font-serif)',
    rounded: 'var(--font-rounded)',
    mono: 'var(--font-mono)',
  },
});

export const Spacing = {
  half: 2,
  one: 4,
  two: 8,
  three: 16,
  four: 24,
  five: 32,
  six: 64,
} as const;

export const Radius = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 20,
} as const;

export const MaxContentWidth = 1280;
export const SidebarWidth = 256;
